import { render, staticRenderFns } from "./CourseDefinitions.vue?vue&type=template&id=c9a3fcac"
import script from "./CourseDefinitions.vue?vue&type=script&lang=js"
export * from "./CourseDefinitions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports